<template>
  <div class="personal-orders">
    <!-- Order List -->
    <div
      v-for="item in orderList"
      :key="item.orderId"
      class="personal-orders-card"
    >
      <div class="personal-orders-card-header">
        <span class="personal-orders-card-number">订单号：{{ item.orderNo }}</span>
        <span class="personal-orders-card-time">下单时间：{{ item.createTime }}</span>
      </div>
      <div class="personal-orders-card-body">
        <span class="personal-orders-card-product">{{ formatProductName(item) }}</span>
        <span class="personal-orders-card-price">¥{{ item.orderAmount }}</span>
        <div class="personal-orders-card-actions">
          <!-- Pay status badge -->
          <span :class="['personal-orders-btn', payStatusClass(item.payStatus, item)]">
            {{ payStatusText(item) }}
          </span>
          <!-- QR code for unpaid orders -->
          <div v-if="item.payStatus === 0 && item.status !== 2" class="personal-orders-qr-block" @click="showQrCode(item)">
            <div class="personal-orders-qr-text">点击扫码支付</div>
            <img class="personal-orders-qr-icon" :src="qrCodeImg" alt="扫码支付">
          </div>
          <!-- Invoice status & actions (only when payStatus === 1) -->
          <template v-if="item.payStatus === 1">
            <span
              v-if="item.invoiceApplyStatus !== null && item.invoiceApplyStatus !== undefined"
              :class="['personal-orders-btn', invoiceStatusClass(item.invoiceApplyStatus)]"
            >
              {{ invoiceStatusText(item.invoiceApplyStatus) }}
            </span>
            <!-- 申请发票 -->
            <span
              v-if="item.invoiceApplyStatus === null || item.invoiceApplyStatus === undefined"
              class="personal-orders-btn personal-orders-btn-invoice"
              @click="openApplyInvoice(item)"
            >申请发票</span>
            <!-- 修改发票 -->
            <span
              v-if="[0, 2, 3].includes(item.invoiceApplyStatus)"
              class="personal-orders-btn personal-orders-btn-invoice"
              @click="openEditInvoice(item)"
            >修改发票</span>
            <!-- 查看发票 -->
            <span
              v-if="item.invoiceApplyStatus === 1"
              class="personal-orders-btn personal-orders-btn-invoice"
              @click="viewInvoice(item)"
            >查看发票</span>
            <!-- 售后服务 -->
            <span
              class="personal-orders-btn personal-orders-btn-after-sales"
              @click="showAfterSalesInfo(item)"
            >售后服务</span>
          </template>
        </div>
      
      </div>
          <!-- 收货人信息 -->
        <div v-if="item.receiverName" class="personal-orders-receiver">
          <div class="receiver-row">
            <span class="receiver-label">收货人：</span>
            <span class="receiver-value">{{ item.receiverName }}</span>
            <span class="receiver-phone"> {{ item.receiverPhone }}</span>
          </div>
          <div class="receiver-row">
            <span class="receiver-label">地址：</span>
            <span class="receiver-value">
              {{ item.receiverProvinceName }}
              {{ item.receiverCityName }}
              {{ item.receiverDistrictName }}
              {{ item.receiverAddress }}
            </span>
          </div>
           <div class="receiver-row" v-if="item.status===3 || item.status===4">
            <span class="receiver-label">快递信息：</span>
            <span class="receiver-value">{{ item.status===3?'已发货' : '已收货' }}</span>
            <span class="receiver-phone"> {{ item.receiverPhone }}</span>
          </div>
        </div>
    </div>
    <!-- Empty state -->
    <div v-if="orderList.length === 0" class="personal-orders-empty">
      <div class="personal-orders-empty-icon" />
      <div class="personal-orders-empty-text">暂无订单</div>
    </div>

    <!-- Invoice Popup -->
    <div v-if="showInvoicePopup" class="invoice-popup-overlay" @click.self="closeInvoicePopup">
      <div class="invoice-popup">
        <div class="invoice-popup-title">{{ invoicePopupTitle }}</div>
        <div class="invoice-popup-body">
          <div class="invoice-popup-row">
            <label class="invoice-popup-label">发票类型</label>
            <span class="invoice-popup-value">电子普通发票</span>
          </div>
          <div class="invoice-popup-row">
            <label class="invoice-popup-label">发票内容</label>
            <span class="invoice-popup-value">商品明细</span>
          </div>
          <div class="invoice-popup-row">
            <label class="invoice-popup-label">发票抬头</label>
            <div class="invoice-popup-radio-group">
              <label class="invoice-popup-radio">
                <input v-model="invoiceForm.titleType" type="radio" :value="0">
                <span>个人</span>
              </label>
              <label class="invoice-popup-radio">
                <input v-model="invoiceForm.titleType" type="radio" :value="1">
                <span>单位</span>
              </label>
            </div>
          </div>
          <!-- Personal fields -->
          <template v-if="invoiceForm.titleType === 0">
            <div class="invoice-popup-row">
              <label class="invoice-popup-label">发票抬头</label>
              <input
                v-model="invoiceForm.personalTitle"
                class="invoice-popup-input"
                placeholder="请输入个人姓名（最多 30 个字符）"
                maxlength="30"
                :maxlength-show="true"
              >
            </div>
            <div class="invoice-popup-row">
              <label class="invoice-popup-label">电话号码</label>
              <input
                v-model="invoiceForm.personalPhone"
                class="invoice-popup-input"
                placeholder="请输入电话号码（最多 20 个字符）"
                maxlength="20"
                type="number"
                :maxlength-show="true"
              >
            </div>
          </template>
          <!-- Company fields -->
          <template v-if="invoiceForm.titleType === 1">
            <div class="invoice-popup-row">
              <label class="invoice-popup-label">单位名称</label>
              <input
                v-model="invoiceForm.companyName"
                class="invoice-popup-input"
                placeholder="请输入单位名称（最多 30 个字符）"
                maxlength="30"
                :maxlength-show="true"
              >
            </div>
            <div class="invoice-popup-row">
              <label class="invoice-popup-label">统一社会信用代码</label>
              <input
                v-model="invoiceForm.taxNo"
                class="invoice-popup-input"
                placeholder="请输入统一社会信用代码（最多 30 个字符）"
                maxlength="30"
                :maxlength-show="true"
              >
            </div>
            <div class="invoice-popup-row">
              <label class="invoice-popup-label">单位电话</label>
              <input
                v-model="invoiceForm.companyPhone"
                class="invoice-popup-input"
                placeholder="请输入单位电话（最多 20 个字符）"
                maxlength="20"
                :maxlength-show="true"
              >
            </div>
          </template>
          <!-- Audit info (rejected) -->
          <template v-if="invoiceDetail && invoiceDetail.status === 2">
            <div class="invoice-popup-row invoice-popup-row-audit">
              <label class="invoice-popup-label">拒绝原因</label>
              <span class="invoice-popup-value invoice-popup-value-audit">{{ invoiceDetail.auditRemark || '无' }}</span>
            </div>
            <div class="invoice-popup-row invoice-popup-row-audit">
              <label class="invoice-popup-label">审核时间</label>
              <span class="invoice-popup-value">{{ invoiceDetail.auditTime || '无' }}</span>
            </div>
          </template>
        </div>
        <div class="invoice-popup-actions">
          <button class="invoice-popup-btn invoice-popup-btn-close" @click="closeInvoicePopup">关闭</button>
          <!-- Edit mode: pending(0) or rejected(2) → 取消申请 + 提交 -->
          <template v-if="invoicePopupMode === 'edit' && invoiceDetail && [0, 2].includes(invoiceDetail.status)">
            <button class="invoice-popup-btn invoice-popup-btn-cancel" @click="cancelInvoiceApply">取消申请</button>
            <button class="invoice-popup-btn invoice-popup-btn-submit" @click="submitUpdateInvoice">提交</button>
          </template>
          <!-- Edit mode: cancelled(3) → 重新申请 -->
          <template v-if="invoicePopupMode === 'edit' && invoiceDetail && invoiceDetail.status === 3">
            <button class="invoice-popup-btn invoice-popup-btn-submit" @click="reapplyInvoice">重新申请</button>
          </template>
          <!-- Apply mode → 提交 -->
          <template v-if="invoicePopupMode === 'apply'">
            <button class="invoice-popup-btn invoice-popup-btn-submit" @click="submitApplyInvoice">提交</button>
          </template>
        </div>
      </div>
    </div>

    <!-- QR Code Popup -->
    <div v-if="showQrPopup" class="my-orders-qr-popup-overlay" @click.self="closeQrPopup">
      <div class="my-orders-qr-popup">
        <div class="my-orders-qr-popup-title">扫码支付</div>
        <div class="my-orders-qr-popup-body">
          <div v-if="qrLoading" class="my-orders-qr-popup-loading">正在生成二维码...</div>
          <div v-show="!qrLoading" class="my-orders-qr-popup-code" ref="qrcodeContainer" />
          <div class="my-orders-qr-popup-amount">¥{{ currentQrOrder ? Number(currentQrOrder.orderAmount).toFixed(2) : '' }}</div>
          <div class="my-orders-qr-popup-hint">请使用微信扫码支付</div>
        </div>
        <div class="my-orders-qr-popup-actions">
          <button class="my-orders-qr-popup-btn" @click="closeQrPopup">关闭</button>
        </div>
      </div>
    </div>

    <!-- After Sales Info Popup -->
    <div v-if="showAfterSalesPopup" class="after-sales-popup-overlay" @click.self="closeAfterSalesPopup">
      <div class="after-sales-popup">
        <div class="after-sales-popup-title">售后说明</div>
        <div class="after-sales-popup-body">
          <div v-html="afterSalesContent"></div>
        </div>
        <div class="after-sales-popup-actions">
          <button class="after-sales-popup-btn" @click="closeAfterSalesPopup">知道了</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { fetchOrderList, fetchInvoiceApplyDetail, applyInvoice, updateInvoice, cancelInvoiceApply, wxUnifiedOrder, getPayStatus } from '../../api'
import request from '../detail/api/request'

export default {
  name: 'MyOrders',
  data() {
    return {
      orderList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      showInvoicePopup: false,
      invoicePopupMode: 'apply',
      currentOrder: null,
      invoiceForm: {
        titleType: 0,
        personalTitle: '',
        personalPhone: '',
        companyName: '',
        taxNo: '',
        companyPhone: ''
      },
      invoiceDetail: null,
      submitting: false,
      showQrPopup: false,
      currentQrOrder: null,
      qrLoading: false,
      timer: null,
      showAfterSalesPopup: false,
      afterSalesContent: '',
      afterSalesLoading: false,
      qrCodeImg: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect width='100' height='100' fill='%23fff'/%3E%3Cg fill='%23333' fill-rule='evenodd'%3E%3Cpath d='M5 5h25v25h-25zm5 5v15h15v-15zm5 5h5v5h-5z'/%3E%3Cpath d='M70 5h25v25h-25zm5 5v15h15v-15zm5 5h5v5h-5z'/%3E%3Cpath d='M5 70h25v25h-25zm5 5v15h15v-15zm5 5h5v5h-5z'/%3E%3Crect x='35' y='5' width='5' height='5'/%3E%3Crect x='45' y='10' width='5' height='5'/%3E%3Crect x='55' y='5' width='5' height='5'/%3E%3Crect x='40' y='15' width='5' height='5'/%3E%3Crect x='50' y='20' width='5' height='5'/%3E%3Crect x='60' y='15' width='5' height='5'/%3E%3Crect x='35' y='25' width='5' height='5'/%3E%3Crect x='45' y='30' width='5' height='5'/%3E%3Crect x='55' y='25' width='5' height='5'/%3E%3Crect x='65' y='30' width='5' height='5'/%3E%3Crect x='75' y='35' width='5' height='5'/%3E%3Crect x='85' y='30' width='5' height='5'/%3E%3Crect x='40' y='40' width='5' height='5'/%3E%3Crect x='50' y='35' width='5' height='5'/%3E%3Crect x='60' y='40' width='5' height='5'/%3E%3Crect x='70' y='45' width='5' height='5'/%3E%3Crect x='80' y='40' width='5' height='5'/%3E%3Crect x='90' y='45' width='5' height='5'/%3E%3Crect x='35' y='50' width='5' height='5'/%3E%3Crect x='45' y='55' width='5' height='5'/%3E%3Crect x='55' y='50' width='5' height='5'/%3E%3Crect x='65' y='55' width='5' height='5'/%3E%3Crect x='75' y='50' width='5' height='5'/%3E%3Crect x='85' y='55' width='5' height='5'/%3E%3Crect x='40' y='60' width='5' height='5'/%3E%3Crect x='50' y='65' width='5' height='5'/%3E%3Crect x='60' y='60' width='5' height='5'/%3E%3Crect x='70' y='65' width='5' height='5'/%3E%3Crect x='80' y='60' width='5' height='5'/%3E%3Crect x='35' y='70' width='5' height='5'/%3E%3Crect x='45' y='75' width='5' height='5'/%3E%3Crect x='55' y='80' width='5' height='5'/%3E%3Crect x='65' y='75' width='5' height='5'/%3E%3Crect x='75' y='80' width='5' height='5'/%3E%3Crect x='85' y='75' width='5' height='5'/%3E%3Crect x='40' y='85' width='5' height='5'/%3E%3Crect x='50' y='90' width='5' height='5'/%3E%3Crect x='60' y='85' width='5' height='5'/%3E%3Crect x='70' y='90' width='5' height='5'/%3E%3Crect x='80' y='85' width='5' height='5'/%3E%3Crect x='90' y='90' width='5' height='5'/%3E%3C/g%3E%3C/svg%3E"
    }
  },
  computed: {
    invoicePopupTitle() {
      return this.invoicePopupMode === 'apply' ? '申请发票' : '发票信息'
    }
  },
  mounted() {
    this.getOrderList()
  },
  beforeDestroy() {
    this.stopPaymentCheck()
  },
  methods: {
    // 根据订单刊期类型和介质类型格式化产品名称
    formatProductName(item) {
      const periodTypeMap = { 1: '单期', 2: '年度订阅' }
      const mediaTypeMap = { 1: '电子版', 2: '纸质版' }
      const periodTypeText = periodTypeMap[item.periodType] || ''
      const mediaTypeText = mediaTypeMap[item.mediaType] || ''
      const year = item.year || ''

      if (item.periodType === 2) {
        return `${year}年${periodTypeText}${mediaTypeText}`
      }

      const issue = String(item.issueNumber || '').padStart(2, '0')
      return `${year}年第${issue}期${mediaTypeText}`
    },
    payStatusText(item) {
      if (item.status === 2) return '已取消'
      const map = { 0: '待支付', 1: '支付成功', 2: '支付失败', 3: '已取消' }
      return map[item.payStatus] || '未知'
    },
    payStatusClass(status, orderItem) {
      // 如果订单已取消，统一使用已取消样式
      if (orderItem && orderItem.status === 2) {
        return 'personal-orders-btn-cancel-disabled'
      }
      const map = {
        0: 'personal-orders-btn-pending',
        1: 'personal-orders-btn-paid',
        2: 'personal-orders-btn-failed',
        3: 'personal-orders-btn-cancel'
      }
      return map[status] || ''
    },
    invoiceStatusText(status) {
      if (status === null || status === undefined) return '发票未申请'
      const map = { 0: '发票待审核', 1: '发票已开票', 2: '发票已拒绝', 3: '发票已取消' }
      return map[status] || '发票未申请'
    },
    invoiceStatusClass(status) {
      if (status === null || status === undefined) return 'personal-orders-btn-invoice-none'
      const map = {
        0: 'personal-orders-btn-invoice-pending',
        1: 'personal-orders-btn-invoice-done',
        2: 'personal-orders-btn-invoice-rejected',
        3: 'personal-orders-btn-invoice-cancelled'
      }
      return map[status] || 'personal-orders-btn-invoice-none'
    },
    async getOrderList() {
      try {
        const data = await fetchOrderList(this.pageNum, this.pageSize)
        this.orderList = data.records || []
        this.total = data.total || 0
      } catch (err) {
        Toast(err.message || '获取订单列表失败')
      } finally {
        this.$emit('loaded')
      }
    },
    resetInvoiceForm() {
      this.invoiceForm = {
        titleType: 0,
        personalTitle: '',
        personalPhone: '',
        companyName: '',
        taxNo: '',
        companyPhone: ''
      }
    },
    openApplyInvoice(order) {
      this.invoicePopupMode = 'apply'
      this.currentOrder = order
      this.invoiceDetail = null
      this.resetInvoiceForm()
      this.showInvoicePopup = true
    },
    async openEditInvoice(order) {
      this.invoicePopupMode = 'edit'
      this.currentOrder = order
      this.invoiceDetail = null
      this.resetInvoiceForm()
      this.showInvoicePopup = true
      try {
        const detail = await fetchInvoiceApplyDetail(order.invoiceApplyId)
        this.invoiceDetail = detail
        this.invoiceForm = {
          titleType: detail.titleType !== undefined ? detail.titleType : 0,
          personalTitle: detail.personalTitle || '',
          personalPhone: detail.personalPhone || '',
          companyName: detail.companyName || '',
          taxNo: detail.taxNo || '',
          companyPhone: detail.companyPhone || ''
        }
      } catch (err) {
        Toast(err.message || '获取发票信息失败')
        this.showInvoicePopup = false
      }
    },
    viewInvoice(order) {
      if (order.invoiceUrl) {
        window.open(order.invoiceUrl, '_blank')
      } else {
        Toast('暂无发票文件')
      }
    },
    validateForm() {
      if (this.invoiceForm.titleType === 0) {
        if (!this.invoiceForm.personalTitle) {
          Toast('请输入发票抬头')
          return false
        }
        if (!this.invoiceForm.personalPhone) {
          Toast('请输入电话号码')
          return false
        }
        // 验证手机号码格式（11 位数字，以 1 开头）
        const phoneReg = /^1[3-9]\d{9}$/
        if (!phoneReg.test(this.invoiceForm.personalPhone)) {
          Toast('请输入正确的手机号码')
          return false
        }
      } else {
        if (!this.invoiceForm.companyName) {
          Toast('请输入单位名称')
          return false
        }
        if (!this.invoiceForm.taxNo) {
          Toast('请输入统一社会信用代码')
          return false
        }
        if (!this.invoiceForm.companyPhone) {
          Toast('请输入单位电话')
          return false
        }
        // 验证单位电话格式（支持手机号或带区号的座机）
        // 手机号：11 位，以 1 开头，第二位 3-9
        // 带区号座机：(区号)-电话号码，例如 010-12345678、0755-12345678
        const phoneReg = /^1[3-9]\d{9}$|^[0-9]{2,4}-[0-9]{7,8}$/
        if (!phoneReg.test(this.invoiceForm.companyPhone)) {
          Toast('请输入正确的联系电话（手机号或带区号座机）')
          return false
        }
      }
      return true
    },
    buildFormParams() {
      const params = { titleType: this.invoiceForm.titleType }
      if (this.invoiceForm.titleType === 0) {
        params.personalTitle = this.invoiceForm.personalTitle
        params.personalPhone = this.invoiceForm.personalPhone
      } else {
        params.companyName = this.invoiceForm.companyName
        params.taxNo = this.invoiceForm.taxNo
        params.companyPhone = this.invoiceForm.companyPhone
      }
      return params
    },
    async submitApplyInvoice() {
      if (!this.validateForm()) return
      if (this.submitting) return
      this.submitting = true
      try {
        await applyInvoice({
          ...this.buildFormParams(),
          orderNo: this.currentOrder.orderNo
        })
        Toast('申请成功')
        this.showInvoicePopup = false
        this.getOrderList()
      } catch (err) {
        Toast(err.message || '申请失败')
      } finally {
        this.submitting = false
      }
    },
    async submitUpdateInvoice() {
      if (!this.validateForm()) return
      if (this.submitting) return
      this.submitting = true
      try {
        await updateInvoice({
          ...this.buildFormParams(),
          id: this.currentOrder.invoiceApplyId
        })
        Toast('修改成功')
        this.showInvoicePopup = false
        this.getOrderList()
      } catch (err) {
        Toast(err.message || '修改失败')
      } finally {
        this.submitting = false
      }
    },
    async reapplyInvoice() {
      if (!this.validateForm()) return
      if (this.submitting) return
      this.submitting = true
      try {
        await updateInvoice({
          ...this.buildFormParams(),
          id: this.currentOrder.invoiceApplyId
        })
        Toast('重新申请成功')
        this.showInvoicePopup = false
        this.getOrderList()
      } catch (err) {
        Toast(err.message || '申请失败')
      } finally {
        this.submitting = false
      }
    },
    async cancelInvoiceApply() {
      if (this.submitting) return
      this.submitting = true
      try {
        await cancelInvoiceApply(this.currentOrder.invoiceApplyId)
        Toast('取消申请成功')
        this.showInvoicePopup = false
        this.getOrderList()
      } catch (err) {
        Toast(err.message || '取消失败')
      } finally {
        this.submitting = false
      }
    },
    closeInvoicePopup() {
      this.showInvoicePopup = false
      this.currentOrder = null
      this.invoiceDetail = null
    },
    async showQrCode(order) {
      this.currentQrOrder = order
      this.showQrPopup = true
      this.qrLoading = true
      try {
        const data = await wxUnifiedOrder(order.orderNo, 'web')
        if (data.code_url) {
          this.qrLoading = false
          this.$nextTick(() => {
            this.generateQRCode(data.code_url)
          })
          this.startPaymentCheck(order.orderNo)
        } else {
          Toast('获取支付二维码失败，请重试')
          this.showQrPopup = false
        }
      } catch (err) {
        Toast(err.message || '获取支付二维码失败')
        this.showQrPopup = false
      } finally {
        this.qrLoading = false
      }
    },
    generateQRCode(url) {
      const container = this.$refs.qrcodeContainer
      if (!container) return
      container.innerHTML = ''
      const QRCode = require('qrcodejs2')
      new QRCode(container, {
        text: url,
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    startPaymentCheck(orderNo) {
      if (this.timer) clearInterval(this.timer)
      this.timer = setInterval(async () => {
        try {
          const data = await getPayStatus(orderNo)
          if (data.payStatus === 1) {
            this.stopPaymentCheck()
            Toast('支付成功')
            this.showQrPopup = false
            this.getOrderList()
          }
        } catch (err) {
          console.error('检查支付状态失败', err)
        }
      }, 1000)
    },
    stopPaymentCheck() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    closeQrPopup() {
      this.stopPaymentCheck()
      this.showQrPopup = false
      this.currentQrOrder = null
    },
    async showAfterSalesInfo() {
      if (this.afterSalesLoading) return
      this.afterSalesLoading = true
      try {
        //const content = await fetchSiteConfig('web.order.keyword.tip')
         const content = await request.post('/api/index/getOrderTip')
        this.afterSalesContent = content.data || '<p>暂无售后服务</p>'
        this.showAfterSalesPopup = true
      } catch (err) {
        Toast(err.message || '获取售后服务失败')
        this.afterSalesContent = '<p>加载失败，请稍后重试</p>'
      } finally {
        this.afterSalesLoading = false
      }
    },
    closeAfterSalesPopup() {
      this.showAfterSalesPopup = false
      this.afterSalesContent = ''
    }
  }
}
</script>

<style lang="scss" scoped>
// After Sales Popup
.after-sales-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  .after-sales-popup {
    width: 90%;
    max-width: 500px;
    max-height: 80vh;
    overflow-y: auto;
    background: #fff;
    border-radius: 12px;
    padding: 24px;

    &-title {
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 24px;
    }

    &-body {
      font-size: 14px;
      line-height: 1.8;
      color: #333;
      margin-bottom: 24px;

      :deep(p) {
        margin-bottom: 12px;
      }

      :deep(p:last-child) {
        margin-bottom: 0;
      }

      :deep(a) {
        color: #2196f3;
      }

      :deep(ul),
      :deep(ol) {
        margin: 12px 0;
        padding-left: 24px;
      }

      :deep(li) {
        margin-bottom: 8px;
      }
    }

    &-actions {
      display: flex;
      justify-content: center;
    }

    &-btn {
      min-width: 100px;
      padding: 12px 24px;
      background: #2196f3;
      color: #fff;
      border: none;
      border-radius: 8px;
      font-size: 14px;
      cursor: pointer;
    }
  }
}
</style>
